<template lang="pug">
  div.lmm-content-body-padded
    b-container(fluid)
      b-row
        b-col.page-wrap(cols="12")
          div(slot="header").d-flex.justify-content-between.page-header
          b-container(fluid)
            b-row
              b-card.w-100(no-body)
                div(slot="header") {{$t('blocking-settings')}}
                b-list-group(flush)
                  b-list-group-item
                    b-row
                      b-col(cols="5" md="5" lg="2") {{$t('blocking-super-settings')}}
                      b-col(cols="7" md="7" lg="10")
                        switches.lmm-switch(
                          v-model="policySet.policy_use",
                          theme="bootstrap",
                          :color="policySet.policy_use ? 'warning' : 'default'"
                          )
                        span.ml-2.ref {{$t('blocking-super-settings-desc')}}
                  b-list-group-item
                    b-row
                      b-col(cols="5" md="5" lg="2") {{$t('blocking-settings01')}}
                      b-col(cols="7" md="7" lg="10")
                        switches.lmm-switch(
                          v-model="policySet.block",
                          theme="bootstrap",
                          :color="policySet.block ? 'warning' : 'default'",
                          :disabled="!policySet.policy_use"
                          )
                        span.ml-2.ref(v-if="policySet.block")
                          | {{$t('blocking-settings-desc02')}}
                        span.ml-2.ref(v-else)
                          | {{$t('blocking-settings-desc01')}}
            b-row
              b-card.mt-4.w-100(no-body)(v-if="policySet.policy_use")
                div(slot="header") {{$t('blocking-settings-ip-list')}}
                b-col
                  b-row.d-flex.align-items-start.ml-3.mt-4
                    b-form-radio-group(
                      v-model="ipAddSort",
                      :options="ipAddSortOption")
                    b-form-group(style="display: flex; align-items: center;")
                      i.fas.fa-question-circle.fa-lg(
                        @click="helpIPAdd"
                      )
                  b-row.mt-2.ml-3
                    b-input-group(v-if="ipAddSort === 'single'")
                      b-col(cols="12", style="display: flex")
                        b-form-input.w-20.d-inline-block(
                          :class="{'w-30': AppState.isMobile, 'w-20 d-inline-block': !AppState.isMobile}"
                          size="sm",
                          :placeholder="$t('single-ip')",
                          v-model="policySet.start_ip_address",
                          @input="isValidSingle")
                        b-form-input.ml-2.w-20.d-inline-block(
                          size="sm",
                          :placeholder="$t('reason')",
                          v-model="policySet.reason")
                        b-button.ml-4(@click="IPSubmit", size="sm") {{$t('add_ip')}}
                    b-input-group(v-else-if="ipAddSort === 'range'")
                      b-col(cols="12")
                        b-form-input.w-20.d-inline-block(
                          size="sm",
                          :placeholder="$t('range-ip-start')",
                          v-model="policySet.start_ip_address",
                          @input="isValidRange")
                        b-form-input.w-20.d-inline-block(
                          size="sm",
                          :placeholder="$t('range-ip-end')",
                          v-model="policySet.end_ip_address",
                          @input="isValidRange")
                        b-form-input.ml-2.w-20.d-inline-block(
                          size="sm",
                          :placeholder="$t('reason')",
                          v-model="policySet.reason")
                        b-button.ml-4(@click="IPSubmit", size="sm") {{$t('add_ip')}}
                    b-input-group(v-else-if="ipAddSort === 'subnet'")
                      b-col(cols="12")
                        b-form-input.w-20.d-inline-block(
                          size="sm",
                          :placeholder="$t('subnet-ip')",
                          v-model="policySet.start_ip_address",
                          @input="isValidSubnet")
                        b-form-input.w-20.ml-2.d-inline-block(
                          size="sm",
                          :placeholder="$t('reason')",
                          v-model="policySet.reason")
                        b-button.ml-4(@click="IPSubmit", size="sm") {{$t('add_ip')}}
                    b-input-group(v-else)
                      b-col(cols="7" md="7" lg="10")
                        b-button(v-if="lang === 'en'" size="sm", variant="primary", target="_blank", :href="`${IPPolicy}/linkmemine_ip_policy_form_en.xlsx`", download) {{$t('excel-form')}}
                        b-button(v-else size="sm", variant="primary", target="_blank", :href="`${IPPolicy}/linkmemine_ip_policy_form_ko.xlsx`", download) {{$t('excel-form')}}
                      b-col.mt-2(cols="6")
                        b-form-file(@change="readFile")
                      b-button.mt-2(@click="excelIPSubmit", size="sm") {{$t('add_ip')}}
                  b-col.mt-4.ml-3
                    b-button.delete-button(
                      size="sm",
                      variant="danger"
                      @click="IPDelete"
                    ) {{$t('delete_ip')}}
                    b-button.ml-2(
                      size="sm",
                      @click="IPDeleteAll"
                    ) {{$t('ip_delete_all')}}
                b-table.mt-2(
                  ref="IPTable",
                  :fields="fields",
                  :items="policySet.list",
                  :empty-text="$t('no-content')",
                  show-empty,
                )
                  template(slot="table-colgroup")
                    col()
                    col()
                    col()
                    col()

                  //- template(slot="HEAD_delete", slot-scope="data")
                  //-   | {{$t('columns.last_connected_time')}}
                  //- template(slot="HEAD_time_added", slot-scope="data")
                  //-   b-form-checkbox
                  //- template(slot="HEAD_ip_address", slot-scope="data")
                  //-   b-form-checkbox
                  //- template(slot="HEAD_reason", slot-scope="data")
                  //-   b-form-checkbox

                  template(v-slot:cell(delete)="data")
                    b-form-checkbox(
                      v-model="data.item.delete"
                      )
                  template(v-slot:cell(time_added)="data")
                    //- |{{data.item.time_added| moment('add', AppState.Info.timezoneOffsetLocal, AppState.Info.dateFmt + ' HH:mm:ss')}}
                    |{{data.item.time_added| moment('add', AppState.Info.timezoneOffset, AppState.Info.dateFmt + ' HH:mm:ss')}}
                  template(v-slot:cell(start_ip_address)="data")
                    |{{data.item.start_ip_address[0]}}
                    span(v-if="data.item.end_ip_address != ''")
                      |  ~
                    |{{data.item.end_ip_address[0]}}
                  template(v-slot:cell(reason)="data")
                    |{{data.item.reason}}
              //div.mt-2.d-flex
              //  b-btn(@click="blockingSubmit", variant="primary") {{$t('save')}}
            b-row.d-flex.flex-row-reverse
              b-btn.mt-2.save-btn(@click="blockingSubmit", size="sm") {{$t('save')}}
              b-btn.mt-2.mr-1.cancel-button(size="sm") {{$t('cancel')}}
</template>

<script>
import _ from 'lodash'
import Switches from 'vue-switches'
import XLSX from 'xlsx'
import {IPPolicyAPI} from '@/api'
import { HeaderWithoutMenu } from '@/components/mixins/header'
import ToggleBox from '@/components/mixins/togglebox'
import store from '@/api/store'

export default {
  name: 'blocking-settings-component',
  components: { HeaderWithoutMenu, ToggleBox, Switches },
  methods: {
    isValidSingle () {
      let single = this.policySet.start_ip_address
      if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/g.test(single)) {
        this.validates.single = true
      } else {
        this.validates.single = false
      }
    },
    isValidRange () {
      let rangeStart = this.policySet.start_ip_address
      let rangeEnd = this.policySet.end_ip_address
      if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/g.test(rangeStart) && /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/g.test(rangeEnd)) {
        this.validates.range = true
      } else {
        this.validates.range = false
      }
    },
    isValidSubnet () {
      let subnet = this.policySet.start_ip_address
      if (/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])((\/)([1-9]|[1-2][0-9]|3[0-2])){0,1}$/g.test(subnet)) {
        this.validates.subnet = true
      } else {
        this.validates.subnet = false
      }
    },
    checkedSet () {
      this.checked.push(this.policySet.list)
    },
    async getData () {
      const resp=await IPPolicyAPI.get()

      this.policySet = resp.data.objects
      return resp.data.objects
    },
    blockingSubmit () {
      let params = {
        type: 'set',
        policy_use: this.policySet.policy_use,
        block: this.policySet.block
      }
      IPPolicyAPI.post('', params)
        .then(resp => {
          this.AppState.$emit('show-message-dialog', {
            title: 'LinkMeMine',
            context: {path: 'blocking-submit'}
          })
          // this.$router.push({name: 'managers'})
        })
    },
    IPSubmit () {
      const vd = this.validates
      if (this.ipAddSort === 'single' && !vd.single) {
        this.AppState.$emit('show-message-dialog', {
          title: 'LinkMeMine',
          context: {path: 'ip_range_error'}
        })
        return
      }
      if (this.ipAddSort === 'range' && !vd.range) {
        this.AppState.$emit('show-message-dialog', {
          title: 'LinkMeMine',
          context: {path: 'ip_range_error'}
        })
        return
      }
      if (this.ipAddSort === 'subnet' && !vd.subnet) {
        this.AppState.$emit('show-message-dialog', {
          title: 'LinkMeMine',
          context: {path: 'ip_range_error'}
        })
        return
      }

      let params = {
        type: 'post',
        start_ip_address: this.policySet.start_ip_address,
        end_ip_address: this.policySet.end_ip_address,
        reason: this.policySet.reason
      }
      IPPolicyAPI.post('', params)
        .then(resp => {
          if (resp.data.status === 200) {
            this.$router.go(this.$router.currentRoute)
          } else if (resp.data.status === 406) {
            this.AppState.$emit('show-message-dialog', {
              title: 'LinkMeMine',
              context: {path: 'ip_range_error'}
            })
          } else if (resp.data.status === 405) {
            this.AppState.$emit('show-message-dialog', {
              title: 'LinkMeMine',
              context: {path: 'ip_range_blank'}
            })
          }
        })
    },
    IPDelete () {
      let params = []

      for (let i in this.policySet.list) {
        if (this.policySet.list[i].delete == true) {
          let param = {
            type: 'delete',
            start_ip_address: this.policySet.list[i].start_ip_address[0],
            end_ip_address: this.policySet.list[i].end_ip_address[0]
          }
          
          // 고차함수 Map param 사용하기 위한 array
          params.push(param)
        }
      }

      Promise.all(
          params.map(async param => {
            // RESTFUL 요청
            return await IPPolicyAPI.post('', param)
          })
        ).then(() => {
          // RESTFUL 요청 완료 코드 (values 값은 array, 각 항목마다 리턴값 values[0], values[1], ...)
          this.$router.go(this.$router.currentRoute)
        })
    },
    IPDeleteAll () {
      let params = {
          context: {path: 'ip_delete_all_warning'},
          withoutInput: true,
          submit: {
            size: 'sm',
            color: 'danger',
            text: 'ip_delete_all'
          }
        }
      this.AppState.$emit('show-confirm-dialog', params, (key, data) => {
        if (key === 'submit') {

          let params = []

          for (let i in this.policySet.list) {
            let param = {
              type: 'delete',
              start_ip_address: this.policySet.list[i].start_ip_address[0],
              end_ip_address: this.policySet.list[i].end_ip_address[0]
            }
            
            // 고차함수 Map param 사용하기 위한 array
            params.push(param)
          }
          
          Promise.all(
            params.map(async param => {
              // RESTFUL 요청
              return await IPPolicyAPI.post('', param)
            })
          ).then(() => {
            // RESTFUL 요청 완료 코드 (values 값은 array, 각 항목마다 리턴값 values[0], values[1], ...)
            this.$router.go(this.$router.currentRoute)
          })
        }
      })
    },
    helpIPAdd () {
      this.AppState.$emit('show-helpOTP-dialog', {
        title: 'LinkMeMine',
        context: {path: 'help_ip_add'}
      })
    },
    readFile (event) {
      const input = event.target
      const reader = new FileReader()
      let tmpResult = {}

      reader.onload = (e) => {
        var fileData = reader.result
        var wb = XLSX.read(fileData, {type : 'binary'})

        wb.SheetNames.forEach(function(sheetName) {
          var rowObj = XLSX.utils.sheet_to_json(wb.Sheets[sheetName])
          var itemList = JSON.stringify(rowObj)
          var obj = JSON.parse(itemList)
          tmpResult[sheetName] = obj
        })
        this.excelSet = tmpResult.Sheet1
      }
      reader.readAsBinaryString(input.files[0])
    },
    excelIPSubmit () {
      if (this.excelSet.length == 0) {
        this.AppState.$emit('show-message-dialog', {
          title: 'LinkMeMine',
          context: {path: 'ip_excel_no_file'}
        })
        return
      }

      let params = []
      for (let i in this.excelSet) {
      
        let param = {
          type: 'post',
          start_ip_address: this.excelSet[i]['IP 주소 (시작)'],
          end_ip_address: this.excelSet[i]['IP 주소 (끝)'],
          reason: this.excelSet[i]['사유']
        }

        if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/g.test(param.start_ip_address) || /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])((\/)([1-9]|[1-2][0-9]|3[0-2])){0,1}$/g.test(param.start_ip_address)) {
          if (param.end_ip_address === undefined || /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/g.test(param.end_ip_address)) {
            // 고차함수 Map param 사용하기 위한 array
            params.push(param)
          }
        }
      }  
      
      Promise.all(
          params.map(async param => {
            // RESTFUL 요청
            return await IPPolicyAPI.post('', param)
          })
        ).then(() => {
          // RESTFUL 요청 완료 코드 (values 값은 array, 각 항목마다 리턴값 values[0], values[1], ...)
          this.$router.go(this.$router.currentRoute)
        })
    },
    getSummary () {
      let stored = store.get('lang')
      this.lang = stored
    }
  },
  mounted () {
    this.getData()
    this.getSummary()
  },
  data () {
    return {
      policySet: {
        policy_use:false,
        list:[],
        block:false,
        unblock:false,
        ip_address: '',
        reason: '',
        ip_check:false,
        delete: false
      },
      excelSet: [],
      ipAddSort: 'single',
      ipAddSortOption:[
        { text: this.$t('add_ip_single'), value: 'single' },
        { text: this.$t('add_ip_range'), value: 'range' },
        { text: this.$t('add_ip_subnet'), value: 'subnet' },
        { text: this.$t('add_ip_excel'), value: 'excel' }
      ],
      validates: {
        single:false,
        range:false,
        subnet:false
      },
      checked:[],
      fields: [
        {
          key: 'delete',
          label: '',
          thAttr: (_, __, ) => ({
            title: `b-form-checkbox`
          })
        },
        {
          key: 'time_added',
          label: this.$t('time-added')
        },
        {
          key: 'start_ip_address',
          label: this.$t('ip-address')
        },
        {
          key: 'reason',
          label: this.$t('reason')
        }
      ],
      IPPolicy: `${this.AppState.Path.download}/IPPolicy`,
      lang: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.lmm-content-body-padded {
  padding: 0;
  margin: 0;
}

.row, .col, .container-fluid, .container {
  margin: 0;
  padding: 0;
}

.page-wrap {
  padding: 1rem 1.5rem;
}

//.page-header {
//  padding: 0 1.5rem 0 1.5rem;
//  margin-bottom: 0.8rem;
//  height: 2rem;
//}

.fas {
    cursor: pointer;
  }

.card {
  border-radius: 0;
  .card-body {
    padding: 0;
  }
  > .card-header {
    border-bottom: 1px solid #D2D2D2;
    font-size: 1.2rem;
    font-weight: 500;
  }
}


.d-flex > .btn {
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  font-weight: 600;
  width: 4rem;
  border-radius: 0;
  height: 1.5rem;
}

.col {
  .btn-danger {
    color: #ffffff;
    background-color: $mainTheme;
    border-color: $mainTheme;
    height: 1.6rem;
    &:hover {
      background-color: $hover !important;
      color: #FFFFFF !important;
      border: 1px solid $hover !important;
      font-weight: 600;
    }
  }
}
//.btn-secondary {
//  border: #D3D3D3 !important;
//  background-color: #D3D3D3 !important;
//  font-weight: 600;
//  color: black !important;
//  height: 1.6rem;
//}

.cancel-button {
  background-color: #ffffff !important;
}

.col-12 {
  align-items: center;
}

.btn-secondary {
  color: black !important;
  font-weight: 400;
}

.btn-secondary:hover {
  color: black !important;
  background-color: #F7F7F7 !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
}

.btn-secondary:active {
  color: black !important;
  background-color: #CBCBCB !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
}

.save-btn {
  color: #FFFFFF !important;
  background-color: $mainTheme !important;
  border: 1px solid $mainTheme !important;
}

.save-btn:hover {
  color: #FFFFFF !important;
  background-color: $hover !important;
  border: 1px solid $hover !important;
  font-weight: 600;
}

::v-deep .b-table {
  margin: 0;
  tr, td, th {
    padding: 0.5rem 0 0.5rem 1rem;
    position: relative;
    font-weight: 400;
  }
  th:nth-child(1) {
    width: 3%;
  }

  th:nth-child(2), th:nth-child(3) {
    width: 20%;
  }
  td {
    color: #6F6F6F;
  }
}
</style>